import { Skeleton } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import classNames from 'classnames';
import Image from 'next/image';
import { isValidElement, ReactNode } from 'react';
import { Loading } from './Loading';

interface IProps {
  title?: string | ReactNode;
  icon?: string | undefined;
  confirmation?: boolean;
  children: React.ReactNode;
  extra?: React.ReactNode;
  showModal: boolean;
  handleCloseModal: () => void;
  loading?: boolean;
  slimPadding?: boolean;
}

export const UnstyledModal = ({
  title,
  icon = undefined,
  confirmation = false,
  children,
  extra,
  showModal,
  handleCloseModal,
  loading = false,
  slimPadding = false,
}: IProps) => {
  const topSection = () => {
    if (icon || title) {
      return (
        <div className={'flex justify-between items-center p-8'}>
          <div className={`flex w-full items-center gap-3`}>
            {icon && (
              <div className="bg-secondary-25 p-3 rounded-2xl">
                <Image src={icon} alt="Close" width={24} height={24} />
              </div>
            )}
            {title &&
              (isValidElement(title) ? (
                title
              ) : (
                <span className={'text-3xl font-bold'}>{title}</span>
              ))}
          </div>
          <button onClick={handleCloseModal} className="self-baseline">
            <IconX
              style={{
                width: '24px',
                height: '24px',
                color: '#000',
                objectFit: 'contain',
              }}
            />
          </button>
        </div>
      );
    }

    return (
      <div className={'flex justify-end items-center px-8 pt-4'}>
        <button onClick={handleCloseModal} className="self-baseline">
          <IconX
            style={{
              width: '24px',
              height: '24px',
              color: '#000',
              objectFit: 'contain',
            }}
          />
        </button>
      </div>
    );
  };
  // ${confirmation ? 'pb-16' : 'py-16'}
  return showModal ? (
    <div className="fixed inset-0 flex items-center justify-center z-10">
      <div className="absolute inset-0 bg-gradient-to-r from-overlay-100/75 to-primary-200/75 backdrop-blur"></div>
      <div className="bg-white rounded-[2rem] transform transition-all w-full sm:max-w-4xl xl:max-w-6xl max-h-[calc(100vh-50px)]  overflow-auto">
        {topSection()}
        {!!extra && extra}
        <div
          className={classNames('px-8', {
            'pb-16': confirmation && !slimPadding,
            'py-16': !confirmation && !slimPadding,
            'py-2': slimPadding,
          })}
        >
          <Loading
            loading={loading}
            skeleton={<Skeleton height={450} className="rounded-[2rem]" />}
          >
            {children}
          </Loading>
        </div>
      </div>
    </div>
  ) : null;
};
